export default "__VITE_ASSET__Ctx0WCg0__"